<template>
    <Head>
        <title>{{title}}</title>
        <meta name="description" :content="description">
    </Head>
    <Header :bg_img="bg_img"></Header>
    <Layout>
        <!-- Hometemplate.php -->
        <div class="to-buy-page-template">
            <section class="page-header-section half-view-header single-view-header content-in-center no-margin">
                <div class="image-block"
                     style="background-image: url('https://www.ewigo.com/wp-content/uploads/2025/02/trouvez_votre_voiture-min.png')">
                </div>
                <div class="container">
                    <h1 class="h1 white anim fade right">Mes Favoris</h1>
                    <h4 class="h4 white anim fade right delay1">pour parcourir les routes en toute sérénité</h4>
                </div>


            </section>

            <section class="points-of-sale-grid-section" id="points-of-sale-grid-section">
                <div class="container">
                    <div class="search-header">
                        <div>
                            <p><b>{{ ads.total }}</b> Résultats</p>
                        </div>
                    </div>
                    <div class="posts-list-grid">
                        <div class="row">
                            <template v-for="(item, index) in ads.data" :key="item.id+JSON.stringify(favoris)">

                                <ad :ad="item" :network="false" :favoris="favoris" v-if="favoris"></ad>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 1">
                                    <a :href="route('minisite.services')+'#livraison'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2021/10/Groupe-362@2x.png');"></div>
                                        </div>
                                    </a>
                                </div>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 4">
                                    <a :href="route('minisite.services')+'#financement'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2021/10/Groupe-363@2x.png');"></div>
                                        </div>
                                    </a>
                                </div>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 7">
                                    <a :href="route('minisite.services')+'#garantie'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2022/05/Garantie-1.png');"></div>
                                        </div>
                                    </a>
                                </div>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 10">
                                    <a :href="route('minisite.services')+'#pack'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2022/05/pack.png');"></div>
                                        </div>
                                    </a>
                                </div>


                            </template>

                        </div>
                    </div>
                </div>
            </section>
        </div>


    </Layout>
    <Footer :bg_img="bg_img"></Footer>
</template>

<script>
import _, {throttle} from 'lodash';
import Layout from './Layout'
import {Head} from '@inertiajs/inertia-vue3'
import Footer from "@/Pages/Partials/ReseauFooter"
import Header from "@/Pages/Partials/ReseauHeader"
import Ad from "@/Pages/Partials/Ad"
import Pagination from '@/Components/Pagination'

export default {
    components: {
        Head,
        Layout,
        Footer,
        Header,
        Ad,
        Pagination,
    },
    props: {
        agency: Object,
        makes: Object,
        models: Object,
        categories: Object,
        energies: Object,
        ads: Object,
        bg_img: String,
        adsNetwork: Object,
        body_class: String,
        title: String,
        description: String,
    },
    data() {
        return {
            isActiveType: false,
            isActiveMarque: false,
            isActiveModele: false,
            isActiveCarburant: false,
            isActiveVitesse: false,
            filter: {
                type: [],
                marque: [],
                modele: [],
                energie: [],
                vitesse: [],
            },
            choices: {
                makes: this.makes,
                models: this.models,
                energies: this.energies,
                categories: this.categories,
                vitesses: ['Automatique', 'Manuelle'],
            },
            sort: '-id',
            kw: '',
            loaded: false,
            sortBy: [
                {value: '-id', label: 'Date du + au - récent'},
                {value: 'id', label: 'Date du - au + récent'},
                {value: '-price', label: 'Prix du + au - cher'},
                {value: 'price', label: 'Prix du - au + cher'},
            ],
            favoris: [],
        }
    },
    watch: {
        filter: {
            deep: true,
            handler: _.debounce(function () {
                //if (this.loaded) {
                this.$inertia.get(route('minisite.acheter') + '?' + this.queryString, {}, {
                    preserveState: true,
                    preserveScroll: true
                })
                //} else {
                //    this.loaded = true
                //}
            }, 300)
        },
        kw: {
            deep: true,
            handler: _.debounce(function () {
                this.$inertia.get(route('minisite.acheter') + '?' + this.queryString, {}, {
                    preserveState: true,
                    preserveScroll: true
                })
            }, 100)
        },
        sort: {
            deep: true,
            handler: _.debounce(function () {
                this.$inertia.get(route('minisite.acheter') + '?' + this.queryString, {}, {
                    preserveState: true,
                    preserveScroll: true
                })
            }, 100)
        },
        'filter.marque': {
            handler: throttle(function () {
                axios.get(route('minisite.models', {makes: this.filter.marque}))
                    .then((response) => {
                        this.choices.models = response.data
                    })
            }, 500)
        }
    },
    created() {
        if (route().params.filter) {
            this.setRouteFilters();
            /*if (!route().params.filter.years) {
                this.setDefaultFilter('years');
            }
            if (!route().params.filter.kms) {
                this.setDefaultFilter('kms');
            }
            if (!route().params.filter.price) {
                this.setDefaultFilter('price');
            }*/
        } else {
            /*this.setDefaultFilter('years');
            this.setDefaultFilter('kms');
            this.setDefaultFilter('price');*/
        }
        //axios.get('https://wvw.ewigo.com/favoris').then((response) => {
        axios.get(route('api.favoris.get')).then((response) => {
            this.favoris = Object.values(response.data)
        });
    },
    beforeUpdate() {
        //this.loaded = true
    },
    mounted() {
        document.body.classList.add(this.body_class.split(' '))
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const elToGoPosition = document.querySelector(this.getAttribute('href')).getBoundingClientRect().top + window.pageYOffset;
                const headerHeight = document.getElementById('masthead').getBoundingClientRect().height;
                window.scrollTo({
                    top: elToGoPosition - headerHeight,
                    behavior: 'smooth'
                });

                // document.querySelector(this.getAttribute('href')).scrollIntoView({
                //     behavior: 'smooth'
                // });
            });
        });
    },
    destroyed() {
        document.body.classList.remove(this.body_class.split(' '))
    },
    computed: {
        queryString() {
            let string = '';
            if (this.filter) {
                _.forEach(this.filter, (value, key) => {
                    if (value === null || value === undefined) {
                        return;
                    }
                    if (Array.isArray(value)) {
                        if (value.length === 0) {
                            return;
                        }
                        string += `filter[${key}]=${encodeURIComponent(value.join(','))}&`;
                    } else if (typeof value === 'boolean') {
                        string += `filter[${key}]=${encodeURIComponent(String(value))}&`;
                    } else {
                        string += `filter[${key}]=${encodeURIComponent(String(value))}&`;
                    }
                });
            }
            string += `sort=${encodeURIComponent(this.sort)}&`;
            string += `kw=${encodeURIComponent(this.kw || '')}`;

            return string;
        },
    },
    methods: {
        setRouteFilters() {
            let filters = route().params.filter
            _.forEach(filters, (filter, name) => {
                this.filter[name] = filter.split(',')
            })
        },
    },

}
</script>
<style scoped lang="scss">

.separator-list-grid {
    margin: 60px 20px;

    p {
        text-align: center;
        width: 100%;
    }
}

.submit-button input:hover {
    background-color: #262626;
    border: 1px solid #262626;
    cursor: pointer;
}


@media screen and (max-width: 768px) {
    .featured {
        /*min-height: 50vh;*/
        height: 400px;
    }
}


.to-buy-page-template .page-header-section .search-section .search-list .list .box-detail {
    &.boxblock {
        display: block;
    }
}


</style>
